<template>
    <b-modal
        id="lesson-module-copy-modal"
        v-model="modal"
        :title="$t('lesson_module.copy')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal new-lesson-module-modal">
        <div class="lesson-module-create-form">
            <b-alert
                v-if="hasError"
                variant="danger"
                show
            >{{ $t('lesson_module.name_is_required') }}
            </b-alert>

            <b-form-group
                class="internship-organization-name"
                label-for="internship-organization-name-input"
                :label="$t('common.name') + ':'">
                <b-form-input
                    id="internship-organization-name-input"
                    v-model="name"
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="education-level-select"
                label-for="niveau"
                :label="$t('common.level') + ':'">
                <design-2021-apprentice-multiselect-component
                    v-model="educationLevel"
                    :options="educationLevels"
                    label="name"
                    track-by="id"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                v-if="!!lessonModuleTypesIn.length"
                class="type-select"
                label-for="type"
                :label="$t('common.type') + ':'">
                <design-2021-apprentice-multiselect-component
                    v-model="type"
                    :options="lessonModuleTypesIn"
                    :allow-empty="true"
                    label="name"
                    track-by="id"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <div class="banner-upload">
                <b-form-file
                    class="apprentice-file-upload"
                    v-model="file"
                    :state="Boolean(file)"
                    :placeholder="$t('files.choose_file') + '...'"
                    drop-placeholder="Drop file here...">
                </b-form-file>

                <div class="preview-banner">
                    <img class="banner-image" v-if="oldFile || imageSRC" :src="imageSRC ?? oldFile.image.lowres_path" />
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import Design2021ApprenticeMultiselectComponent
        from '../../../common/design-2021-apprentice-multiselect-component.vue';

    export default {
        name: 'design-2021-copy-lesson-module-modal-component',
        components: { Design2021ApprenticeMultiselectComponent },
        props: {
            lessonModuleTypesIn: {
                type: Array
            }
        },
        data() {
            return {
                lessonModule: null,
                modal: false,
                name: '',
                educationLevel: null,
                educationLevels: [],
                hasError: false,
                file: null,
                oldFile: null,
                type: null
            };
        },
        computed: {
            imageSRC() {
                if (this.file === null) return null;

                return URL.createObjectURL(this.file);
            }
        },
        methods: {
            show(lessonModule) {
                this.name = lessonModule.name;
                this.educationLevel = lessonModule.education_levels[0];
                this.lessonModule = lessonModule;
                this.type = lessonModule.type;
                this.file = null;
                this.oldFile = lessonModule.banner;
                if (!this.educationLevels.length) {
                    this.axios.get(this.routes.educationLevels()).then(
                        (response) => {
                            this.educationLevels = response.data;
                        },
                        (error) => {
                            this.alert.ajaxError;
                        }
                    );
                }
                this.modal = true;
            },
            save() {
                this.alert.saving();

                let formData = new FormData();
                if (this.file) {
                    formData.append('file', this.file);
                }
                formData.append('type_id', this.type?.id ?? null);
                formData.append('name', this.name);
                formData.append('education_level_id', this.educationLevel.id);

                this.axios.post(this.routes.lessonModuleCopy(this.lessonModule.id), formData).then(
                    (response) => {
                        this.$emit('lesson-module-added', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError;
                    }
                );
            }
        }
    };
</script>

<style scoped lang="scss">
    .preview-banner {
        display: flex;
        margin-top: $grid-gutter-width;
        max-height: 600px;
        text-align: center;
        height: 100%;
    }

    .banner-image {
        object-fit: contain;
        object-position: center;
        width: 100%;
        height: auto;
    }
</style>
